import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

//import Grid from '@material-ui/core/Grid';
//import Button from '@material-ui/core/Button';

//import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';

import Card from '@material-ui/core/Card';
//import CardHeader from '@material-ui/core/CardHeader';
import Paper from '@material-ui/core/Paper';
import CardContent from '@material-ui/core/CardContent';

import * as d3 from 'd3';

//import SocialMediaBlock from "./socialMediaBlock";
import SocialMedia from './socialMedia';

//import Calendar from 'react-calendar';
//import YearView from 'react-calendar';
//import DecadeView from 'react-calendar';

const styles = (theme) => ({
  card: {
    display: 'flex column',
    margin: 0,
    borderColor: 'rgba(255,255,255,0)!important',
    boxShadow: '0px 0px 0px 0px rgba(255,255,255,0)!important',
    backgroundColor: '#f3f3f3',
  },
  cardHeader: {
    //backgroundColor: '#165469',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#fff',
    padding: '5px',
    paddingLeft: '20px',
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'left',
    fontSize: '1.1em',
    fontWeight: 500,
    borderRadius: '5px',
    minHeight: '48px',
  },
  imageBlock: {
    display: 'block',
    margin: '0 auto',
    textIndent: '-9999px',
    backgroundSize: 'contain!important',
    backgroundRepeat: 'no-repeat!important',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: 0,
    minWidth: '40px',
    maxWidth: '40px',
    minHeight: '40px',
    maxHeight: '40px',
  },
  solarOn: {
    background: 'url("/images/vea_selected_energy/solar_white.svg")',
  },
  solarOff: {
    background: 'url("/images/vea_selected_energy/solar_transp_blue.svg")',
  },
  onshoreWindOn: {
    background: 'url("/images/vea_selected_energy/onshoreWind_white.svg")',
  },
  onshoreWindOff: {
    background:
      'url("/images/vea_selected_energy/onshoreWind_transp_blue.svg")',
  },
  offshoreWindOn: {
    background: 'url("/images/vea_selected_energy/offshoreWind_white.svg")',
  },
  offshoreWindOff: {
    background:
      'url("/images/vea_selected_energy/offshoreWind_transp_blue.svg")',
  },
  cardContent: {
    padding: '0!important',
    marginTop: '20px;',
    [theme.breakpoints.up('lg')]: {
      height: '400px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '380px',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '220px',
      height: '220px',
    },
    [theme.breakpoints.down('xs')]: {
      minHeight: '240px',
      height: '240px',
    },
    //fontSize: '1.2em',
    position: 'relative',
  },
  header: {
    paddingLeft: '20px',
    textAlign: 'left',
    fontSize: '1.1em',
    //fontWeight: 700,
  },
  statBlock: {},
});

function parseDate(input) {
  var parts = input.match(/(\d+)/g);
  // note parts[1]-1
  return new Date(parts[2], parts[1] - 1, parts[0]);
}

function CalendarBlockCard(props) {
  const { classes } = props;

  //https://github.com/d3/d3-time-format#timeFormatDefaultLocale
  //https://stackoverflow.com/questions/19274464/how-to-make-localization-on-months-days-for-d3js

  //let locale
  let energyType;

  switch (props.lang) {
    case 'de':
      /*
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
        "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        "months": ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
        "shortMonths": ["", "Jan", "", "Mar", "", "Mai", "", "Jul", "", "Sep", "", "Nov", ""]
      });
      */
      energyType = props.currentTech.solar
        ? props.currentTech.wind
          ? props.currentTech.windOffshore
            ? 'Sonne und Wind onshore und offshore'
            : 'Sonne und Wind onshore'
          : props.currentTech.windOffshore
          ? 'Sonne und Wind offshore'
          : 'Sonne'
        : props.currentTech.wind
        ? props.currentTech.windOffshore
          ? 'Wind onshore und offshore'
          : 'Wind onshore'
        : 'Wind offshore';
      break;
    case 'en':
      /*
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "shortDays": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        "months": ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "shortMonths": ["", "Jan", "", "Mar", "", "May", "", "Jul", "", "Sep", "", "Nov", ""]
      });
      */
      energyType = props.currentTech.solar
        ? props.currentTech.wind
          ? props.currentTech.windOffshore
            ? 'solar and wind onshore and offshore'
            : 'solar and wind onshore'
          : props.currentTech.windOffshore
          ? 'solar and wind offshore'
          : 'solar'
        : props.currentTech.wind
        ? props.currentTech.windOffshore
          ? 'wind onshore and offshore'
          : 'wind onshore'
        : 'wind offshore';
      break;
    case 'fr':
      /*
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
        "shortDays": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
        "months": ["", "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "aôut", "septembre", "octobre", "novembre", "décembre"],
        "shortMonths": ["", "jan", "", "mar", "", "mai", "", "jui", "", "sep", "", "nov", ""]
      });
      */
      energyType = props.currentTech.solar
        ? props.currentTech.wind
          ? props.currentTech.windOffshore
            ? 'solaire et éolienne onshore et offshore'
            : 'solaire et éolienne onshore'
          : props.currentTech.windOffshore
          ? 'solaire et éolienne offshore'
          : 'solaire'
        : props.currentTech.wind
        ? props.currentTech.windOffshore
          ? 'éolienne onshore et offshore'
          : 'éolienne onshore'
        : 'éolienne offshore';
      break;
    case 'nl':
    default:
      /*
      locale = d3.timeFormatDefaultLocale({
        "decimal": ",",
        "thousands": ".",
        "grouping": [3],
        "currency": ["€", ""],
        "dateTime": "%a %b %e %X %Y",
        "date": "%d-%m-%Y",
        "time": "%H:%M:%S",
        "periods": ["AM", "PM"],
        "days": ["zondag", ",maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
        "shortDays": ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
        "months": ["", "januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
        "shortMonths": ["", "jan", "", "maa", "", "mei", "", "jul", "", "sep", "", "nov", ""]
      });
      */
      energyType = props.currentTech.solar
        ? props.currentTech.wind
          ? props.currentTech.windOffshore
            ? 'zon en wind onshore en offshore'
            : 'zon en wind onshore'
          : props.currentTech.windOffshore
          ? 'zon en wind offshore'
          : 'zon'
        : props.currentTech.wind
        ? props.currentTech.windOffshore
          ? 'wind onshore en offshore'
          : 'wind onshore'
        : 'wind offshore';
  }

  let cardHeaderTitle;
  switch (props.lang) {
    case 'de':
      cardHeaderTitle = 'Record values of ' + energyType + ' energy';
      break;
    case 'en':
      cardHeaderTitle = 'Record values of ' + energyType + ' energy';
      break;
    case 'fr':
      cardHeaderTitle = "Record d'énergie " + energyType;
      break;
    case 'nl':
    default:
      cardHeaderTitle = 'Groene stroom - records';
  }

  let dayRecordProduction;
  let dayRecordCoveredDemand;
  let topDays;
  let energyPeak;
  if (
    props.currentTech !== undefined &&
    props.dataLoaded &&
    props.currentTech &&
    Object.prototype.hasOwnProperty.call(props.currentTech, 'solar')
  ) {
    let topDaysData = props.currentTech.solar
      ? props.currentTech.wind
        ? props.currentTech.windOffshore
          ? props.calendarStats.top_days.all
          : props.calendarStats.top_days.combined
        : props.currentTech.windOffshore
        ? props.calendarStats.top_days.solar_offshore
        : props.calendarStats.top_days.solar
      : props.currentTech.wind
      ? props.currentTech.windOffshore
        ? props.calendarStats.top_days.wind_wind
        : props.calendarStats.top_days.wind
      : props.calendarStats.top_days.wind_offshore;
    let energyPeakData = props.currentTech.solar
      ? props.currentTech.wind
        ? props.currentTech.windOffshore
          ? props.calendarStats.energy_peak.all
          : props.calendarStats.energy_peak.combined
        : props.currentTech.windOffshore
        ? props.calendarStats.energy_peak.solar_offshore
        : props.calendarStats.energy_peak.solar
      : props.currentTech.wind
      ? props.currentTech.windOffshore
        ? props.calendarStats.energy_peak.wind_wind
        : props.calendarStats.energy_peak.wind
      : props.calendarStats.energy_peak.wind_offshore;

    let ofTheTotalDemand;
    let ofTheDemandAt;
    let hourAbbreviation = 'u';
    //let correspondingWith
    switch (props.lang) {
      case 'de':
        dayRecordProduction = 'Day with highest production';
        dayRecordCoveredDemand = 'Peak of demand covered';
        ofTheTotalDemand = 'of the total demand';
        ofTheDemandAt = 'of the demand at';
        //correspondingWith = "corresponding with"
        break;
      case 'en':
        dayRecordProduction = 'Day with highest production';
        dayRecordCoveredDemand = 'Peak of demand covered';
        ofTheTotalDemand = 'of the total demand';
        ofTheDemandAt = 'of the demand at';
        //correspondingWith = "corresponding with"
        break;
      case 'fr':
        dayRecordProduction = 'Jour de pointe de production';
        dayRecordCoveredDemand = 'Pic de la demande couverte';
        ofTheTotalDemand = 'de la demande totale';
        ofTheDemandAt = 'de la demande à';
        //correspondingWith = "ce qui correspond à"
        break;
      case 'nl':
      default:
        dayRecordProduction = 'Topdag groenestroomproductie';
        dayRecordCoveredDemand = 'Hoogste piek groenestroomproductie';
        ofTheTotalDemand = 'van de totale vraag ';
        ofTheDemandAt = 'van de vraag om';
      //correspondingWith = "overeenstemmend met"
    }

    topDays = {
      //label: topDaysData.label[props.lang].replace(/^\w/, c => c.toUpperCase()),
      label: topDaysData.label.replace(/^\w/, (c) => c.toUpperCase()),
      text:
        topDaysData.text === 'Niet beschikbaar' ? (
          <div>
            <span className={'classes.bold'}>{topDaysData.text}</span>
          </div>
        ) : (
          /*
          <div style={{ paddingLeft: '30px', textAlign: 'left' }}>
            <div>{dayRecordProduction}</div>
            <div >
              {d3.timeFormat('%e %B %Y')(new Date(parseDate(topDaysData.date)))}
            </div>
            <div>
              {(Math.round(topDaysData.energy.value / 100) / 10).toLocaleString('nl-BE')} GWh = {topDaysData.percentage.value.toLocaleString('nl-BE')}{topDaysData.percentage.unit} {ofTheTotalDemand}
            </div>
          </div>
        */
          <div style={{ paddingLeft: '30px', textAlign: 'left' }}>
            <div>
              Topdag op{' '}
              {d3.timeFormat('%e %B %Y')(new Date(parseDate(topDaysData.date)))}
              :
            </div>
            <div>
              productie van{' '}
              {(Math.round(topDaysData.energy.value / 100) / 10).toLocaleString(
                'nl-BE'
              )}{' '}
              GWh =
            </div>
            <div>
              {topDaysData.percentage.value.toLocaleString('nl-BE')}
              {topDaysData.percentage.unit} van de elektriciteitsvraag
            </div>
          </div>
        ),
    };

    energyPeak = {
      label: energyPeakData.label.replace(/^\w/, (c) => c.toUpperCase()),
      text:
        energyPeakData.text === 'Niet beschikbaar' ? (
          <div>
            <span>{energyPeakData.text}</span>
          </div>
        ) : (
          /*
          <div style={{ paddingLeft: "30px", textAlign: "left" }}>
            <div>{dayRecordCoveredDemand}</div>
            <div>
              {d3.timeFormat("%e %B %Y")(
                new Date(parseDate(energyPeakData.date))
              )}
            </div>
            <div>
              {energyPeakData.percentage.value.toLocaleString("nl-BE")}
              {energyPeakData.percentage.unit} {ofTheDemandAt}{" "}
              {energyPeakData.time}
              {hourAbbreviation} ={" "}
              {(
                Math.round(energyPeakData.energy.value / 100) / 10
              ).toLocaleString("nl-BE")}{" "}
              GWh
            </div>
          </div>
        */
          <div style={{ paddingLeft: '30px', textAlign: 'left' }}>
            <div>
              Hoogste piek op{' '}
              {d3.timeFormat('%e %B %Y')(
                new Date(parseDate(energyPeakData.date))
              )}{' '}
              om {energyPeakData.time}
              {hourAbbreviation}:
            </div>
            <div>
              productie van{' '}
              {(
                Math.round(energyPeakData.energy.value / 100) / 10
              ).toLocaleString('nl-BE')}{' '}
              GWh ={' '}
            </div>
            <div>
              {energyPeakData.percentage.value.toLocaleString('nl-BE')}
              {energyPeakData.percentage.unit} van de elektriciteitsvraag
            </div>
          </div>
        ),
    };
  }

  return (
    <Card className={classes.card}>
      <Paper className={classes.cardHeader + ' headerText bgdarkbluegreen'}>
        {/*
        <div style={{ height: "40px", lineHeight: "40px" }}>
      */}
        <div>
          <div>{cardHeaderTitle}</div>
          <div>
            {props.currentMode === 'realtime'
              ? d3.timeFormat('%Y')(props.selectedDate)
              : props.yearSelected}
          </div>
        </div>
        <div style={{ display: 'flex', paddingTop: '4px' }}>
          <div
            className={
              classes.imageBlock +
              ' ' +
              classes[props.currentTech.solar ? 'solarOn' : 'solarOff']
            }
          ></div>
          <div
            className={
              classes.imageBlock +
              ' ' +
              classes[
                props.currentTech.wind ? 'onshoreWindOn' : 'onshoreWindOff'
              ]
            }
          ></div>
          <div
            className={
              classes.imageBlock +
              ' ' +
              classes[
                props.currentTech.windOffshore
                  ? 'offshoreWindOn'
                  : 'offshoreWindOff'
              ]
            }
          ></div>
        </div>
      </Paper>
      {props.dataLoaded ? (
        <CardContent className={classes.cardContent + ' darkbluegreen'}>
          <div>{topDays.text}</div>
          <div style={{ marginTop: '20px' }}>{energyPeak.text}</div>

          <div
            style={{
              position: 'absolute',
              bottom: '10px',
              right: '10px',
              width: '200px',
            }}
          >
            <SocialMedia
              source="records"
              currentTech={props.currentTech}
              currentMode={props.currentMode}
              yearSelected={props.yearSelected}
              daySelected={props.daySelected}
            />
          </div>
        </CardContent>
      ) : (
        <CardContent className={classes.cardContent}>
          <CircularProgress className={classes.progress} size={50} />
        </CardContent>
      )}
    </Card>
  );
}

CalendarBlockCard.propTypes = {
  classes: PropTypes.object.isRequired,
  selectedDate: PropTypes.object,
  yearSelected: PropTypes.number.isRequired,
  currentTech: PropTypes.object.isRequired,
  currentMode: PropTypes.string.isRequired,
  calendarStats: PropTypes.object.isRequired,
  dataLoaded: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CalendarBlockCard);
